module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<fieldset class="referentielhabr-selecteurref" class="habr-selecteur-view-size">\n  <fieldset class="habr-selecteur-view-size">\n    <legend>\n      '+
((__t=(i18n.t('habr.legend_selectref_criteres')))==null?'':__t)+
'\n    </legend>\n    <input type="text" class="criteres habr-selecteur-view-size" title="" value="" />\n  </fieldset>\n  <div class="table_selecteurref_referentielhabr"></div>\n</fieldset>\n';
}
return __p;
};
